import classNames from 'classnames'
import Button from 'components/forms/Button'
import { useDispatch } from 'react-redux'
import { setSelectedPapers } from 'store/add-report-dashboard-modal/actions'
import { toggleModal, MODAL_FROM_CONTEXTS } from 'store/ui/actions'
import styles from './styles/AddReportToDashboardButton.css'
import { setMode } from '../../store/login-modal/actions'

export const AddReportToDashboardButton = ({
  className = '',
  button = true,
  papers,
  user
}) => {
  const dispatch = useDispatch()

  const anchorText = (
    <>
      <i className={styles.icon} />
      <span className={styles.text}>
        Add to dashboard
      </span>
    </>
  )

  const handleOnClick = () => {
    if (!papers) {
      return
    }
    if (!user?.email) {
      dispatch(setMode('register'))
      dispatch(toggleModal('login', true, MODAL_FROM_CONTEXTS.ADD_REPORT_DASHBOARD))
      return
    }

    dispatch(setSelectedPapers(papers))
    dispatch(toggleModal('addReportToDashboard'))
  }

  return (
    <div className={classNames(className, styles.link)} onClick={handleOnClick}>
      {button
        ? (
          <Button className={styles.button} color={button ? 'blue' : 'white'}>
            {anchorText}
          </Button>
          )
        : (
          <>
            {anchorText}
          </>
          )}
    </div>
  )
}

export default AddReportToDashboardButton
